module.exports = __webpack_public_path__ + "img/earth.0324b84e.png";